import {STYLE_DEFAULT_URL} from '../mapbox-constants/mapbox_constants';
import MobileConfigData from '../mapbox-constants/mobile_config_constants';

const mapState = {
  style: STYLE_DEFAULT_URL,
  doubleClickZoom: false,
  center: MobileConfigData.MAP_INITAL_CENTER,
  centerWithPencilBanner: MobileConfigData.MAP_INITAL_CENTER_PENCIL_BANNER,
  minZoom: MobileConfigData.ZOOM_MIN_SECTIONS,
  maxZoom: MobileConfigData.ZOOM_MAX_SEATS,
};

export default mapState;
